/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BasicAlertComponent } from '../components/alerts/basic-alert.component';
import { EntitlementSpecialStatusCode } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  // Used by app gallery to identify users that need special subscription expired messaging
  public specialStatusCode: number = EntitlementSpecialStatusCode.None; 

  constructor(private modalService: NgbModal) {}

  public displayGeneralError(): NgbModalRef {
    const modalRef = this.modalService.open(BasicAlertComponent);
    modalRef.componentInstance.title = 'SDE_SYSTEM_ENCOUNTERED_ERROR1';
    return modalRef;
  }

  /**
   * Awaitable Basic Alert that allows title and body parameters specified as object or as strings
   */
  public async displayBasicAlert(title: AlertParams): Promise<string>;
  public async displayBasicAlert(title: string, body?: string): Promise<string>;
  public async displayBasicAlert(
    title: AlertParams | string,
    body?: string,
  ): Promise<string> {
    if (typeof title === 'object') {
      body = title.Body;
      title = title.Title;
    }

    const modalRef = this.modalService.open(BasicAlertComponent);
    modalRef.componentInstance.title ??= title;
    modalRef.componentInstance.body ??= body;
    return await modalRef.result;
  }
}

export interface AlertParams {
  Title: string;
  Body?: string;
}
